import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authRepository } from '../../infrastructure/authApiRepository';
import '../styles/auth.css';

export function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState('');

    async function handleSubmit(e) {
        e.preventDefault();
        if (!email) { setError('이메일을 입력해주세요.'); return; }
        setError('');
        setLoading(true);
        try {
            await authRepository.requestPasswordReset(email);
            setSent(true);
        } catch {
            setSent(true); // 가입 여부 노출 방지: 항상 성공 화면 표시
        } finally {
            setLoading(false);
        }
    }

    if (sent) {
        return (
            <div className="auth-page">
                <div className="auth-card">
                    <Link to="/" className="auth-card__logo">
                        <img src="/images/logo/main_logo.png" alt="RISING BROKERS" />
                    </Link>
                    <div className="auth-success">
                        <div className="auth-success__title">이메일을 확인해주세요</div>
                        <div className="auth-success__desc">
                            <span className="auth-success__email">{email}</span>로<br />
                            비밀번호 재설정 링크를 발송했습니다.<br />
                            링크는 1시간 후 만료됩니다.
                        </div>
                        <Link to="/login" className="auth-submit" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none' }}>
                            로그인으로 돌아가기
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="auth-page">
            <div className="auth-card">
                <Link to="/" className="auth-card__logo">
                    <img src="/images/logo/main_logo.png" alt="RISING BROKERS" />
                </Link>
                <div className="auth-card__title">비밀번호 찾기</div>
                <div className="auth-card__sub">가입한 이메일로 재설정 링크를 보내드립니다</div>

                <form className="auth-form" onSubmit={handleSubmit} noValidate>
                    <div className="auth-field">
                        <label>이메일</label>
                        <input
                            className={`auth-input${error ? ' auth-input--error' : ''}`}
                            type="email"
                            placeholder="example@email.com"
                            value={email}
                            onChange={(e) => { setEmail(e.target.value); if (error) setError(''); }}
                            autoComplete="email"
                            autoFocus
                        />
                    </div>

                    {error && <p key={error} className="auth-form-error">{error}</p>}

                    <button className="auth-submit" type="submit" disabled={loading}>
                        {loading ? '발송 중...' : '재설정 링크 발송'}
                    </button>
                </form>

                <div className="auth-links">
                    <Link to="/login">로그인으로 돌아가기</Link>
                </div>
            </div>
        </div>
    );
}
